import React, { ChangeEvent } from "react";
import { DateInput } from "../../components/form-group";
import { DateFormats, formatDate } from "../../core";
import { ContainerLoader } from "../../components/loader";

export interface ISplitMergeProps {
  setIsShown: (i: boolean) => void;
  selectedOption?: any;
  splitUnitsAndProperties?: (propertyId: string, unitId: string, splitPropertyDetails: any[]) => void;
  isSpliting?: boolean;
}

const SplitMerge: React.FunctionComponent<ISplitMergeProps> = (props) => {
  const [selectedFile, setSelectedFile] = React.useState<any>(null);

  const [files, setFiles] = React.useState(['', '']);

  const [splitUnits, setSplitUnits] = React.useState<any[]>([
    {
      unitName: "",
      availableFrom: "",

      unitArea: 0,

      floorPlan: undefined,
    },
    {
      unitName: "",
      availableFrom: "",

      unitArea: 0,
      floorPlan: undefined,
    },
  ]);
  const [isVisible, setIsVisible] = React.useState<boolean>(true);
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedFile(event.target.files[0]);
    }
  };

  const PopupClose = () => {
    props.setIsShown(false);
  };

  const addNewRow = () => {
    setSplitUnits(
      splitUnits.concat([
        {
          unitName: "",
          availableFrom: "",

          unitArea: 0,
          floorPlan: undefined,
        },
      ])
    );

    setFiles(
        files.concat([""
        ])
      );
  };

  const onSubmit = () => {
    props?.splitUnitsAndProperties?.(props.selectedOption?.unitData?.propertyId, props?.selectedOption?.unitData?._id, splitUnits);
  };

  const togglePreview = () => {
    setIsVisible(!isVisible);
  };

  return (
    <>
    {props?.isSpliting ? (
        <>
        <ContainerLoader></ContainerLoader>
      </>
      ) : (
        <div className="">
        <div className="text-body bg-white detail-poupup popup-merge-split detail-poupup--md h-100 in overflow-auto position-fixed top-0 w-100">
          <div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-9">
            <div className="row align-items-center">
              <div className="col-auto">
                <i
                  className="icon-close text-gray-500 font-xxl cursor-pointer"
                  onClick={PopupClose}
                ></i>
              </div>
              <div className="col">
                <div className="mb-0">
                  <h5 className="font-weight-bold text-body">
                    {props.selectedOption?.unitData?.unitName}
                  </h5>
                  <div className="d-flex">
                    <div className="font-sm">
                      <span className="pr-1  text-muted">Total Sq.Ft:</span>
                      <span className="font-sm text-body font-weight-bold">
                        {props.selectedOption?.unitData?.unitArea}
                      </span>
                    </div>
                    <div className="font-sm pl-2">
                      <span className="pr-1  text-muted">Avail:</span>
                      <span className="font-sm text-body font-weight-bold">
                        {props.selectedOption?.unitData?.unitArea}
                      </span>
                    </div>
                    <div className="font-sm pl-2">
                      <span className="pr-1 text-muted">From:</span>
                      <span className="font-sm text-body font-weight-bold">
                        {props.selectedOption?.unitData?.availablefromdate}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="model-body-sec py-3">
            {isVisible ? (
              <div className="entry-details">
                <div className="table-responsive overflow-visible">
                  <table className="table">
                    <thead>
                      <th
                        className="font-sm font-weight-semibold text-muted"
                        style={{ width: "160px" }}
                      >
                        Unit Name
                      </th>
                      <th
                        className="font-sm font-weight-semibold text-muted"
                        style={{ width: "140px" }}
                      >
                        Available From
                      </th>
                      <th
                        className="font-sm font-weight-semibold text-muted"
                        style={{ width: "115px" }}
                      >
                        Total Sq. Ft.
                      </th>
                      {/* <th
                        className="font-sm font-weight-semibold text-muted"
                        style={{ width: "115px" }}
                      >
                        Available Sq. Ft.
                      </th> */}
                      <th
                        className="font-sm font-weight-semibold text-muted"
                        style={{ width: "180px" }}
                      >
                        Floorplan
                      </th>
                    </thead>
                    <tbody>
                      {!!splitUnits && splitUnits?.map((unit, index) => {
                        return (
                          <tr>
                            <td>
                              <div className=" my-2 font-sm font-weight-semibold">
                                <input
                                  type="text"
                                  className="form-control font-weight-semibold font-sm"
                                  placeholder="Unit Name"
                                  defaultValue={unit.unitName}
                                  onChange={(event) => {
                                    unit.unitName = event.target.value;
                                    splitUnits[index] = unit;
                                    setSplitUnits(splitUnits);
                                  }}
                                ></input>
                              </div>
                            </td>
                            <td>
                              <div className="my-2 font-sm font-weight-semibold split-merge-datepicker">
                                {/* <h5 className="mb-0 font-sm font-weight-semibold">01/01/2023</h5> */}
                                <DateInput
                                  label="Date"
                                  placeholder="Date"
                                  default={unit.availableFrom}
                                  onChange={(event) => {
                                    unit.availableFrom = event;
                                    splitUnits[index] = unit;
                                    setSplitUnits(splitUnits);
                                  }}
                                  minDate={new Date()}
                                />
                              </div>
                            </td>
                            <td>
                              <div className=" my-2  font-sm font-weight-semibold">
                                <input
                                  type="text"
                                  className="form-control font-weight-semibold font-sm"
                                  placeholder="Total Sq. Ft."
                                  defaultValue={unit.unitArea}
                                  onChange={(event) => {
                                    unit.unitArea = event.target.value;
                                    splitUnits[index] = unit;
                                    setSplitUnits(splitUnits);
                                  }}
                                ></input>
                              </div>
                            </td>
                            {/* <td>
                              <div className=" my-2 font-sm font-weight-semibold">
                                <input
                                  type="text"
                                  className="form-control font-weight-semibold font-sm"
                                  placeholder="5250"
                                ></input>
                              </div>
                            </td> */}
                            <td>
                              <div className=" my-2 font-sm font-weight-semibold">
                                <input
                                  type="file"
                                  className="d-none"
                                  onChange={(event) => {
                                    unit.floorPlan = event.target.files?.[0];
                                    splitUnits[index] = unit;
                                    setSplitUnits(splitUnits);
                                    files[index] = splitUnits?.[index]?.floorPlan?.name;
                                    setFiles([...files]);
                                  }}
                                  id={`${index}`}
                                />
                                <label
                                  htmlFor={`${index}`}
                                  className="rounded text-center font-normal uploading w-100 m-0 cursor-pointer d-flex align-items-center form-control"
                                >
                                  <span className="d-flex align-items-center">
                                    <i className="icon-upload font-xxl"></i>
                                    <span className="default-upload-label">
                                      <span className="d-block font-weight-semibold">
                                        {files?.[index] && (
                                          <p className="mb-0 font-sm pl-2 file max-w-125 text-truncate" id={`file${index}`}>
                                            {files?.[index]}
                                          </p>
                                        )}
                                      </span>
                                      <span className="font-sm  d-block text-body font-weight-semibold pl-2 max-w-125 text-truncate">
                                        {files?.[index] ? "" : "Upload Floorplan"}
                                      </span>
                                    </span>
                                  </span>
                                </label>

                                {/* <Dropzone
            
            multiple={false}
            >
            {({ getRootProps, getInputProps }) => (
                <div
                {...getRootProps({
                    className: 'drag-drop-file',
                })}
                >
                <input {...getInputProps()} className="d-none" />
                <label
                    htmlFor="upload"
                    className="upload p-3 rounded text-center font-normal uploading w-100 m-0 cursor-pointer d-flex align-items-center justify-content-center"
                    
                    
                
                >
                    <span className="d-block">
                    <i className="icon-upload font-xxl"></i>
                    <span className="default-upload-label">
                        <span className="d-block font-weight-semibold mt-2 py-1">
                        xys
                        </span>
                        <span className="d-block text-gray-500 text-decoration-underline">
                        Drag the file here. Or Click here
                        </span>
                    </span>
                    </span>
                </label>
                </div>
            )}
            </Dropzone> */}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td colSpan={5}>
                          <div className="text-right">
                            <a
                              className="font-sm font-weight-bold text-primary cursor-pointer"
                              onClick={() => addNewRow()}
                            >
                              <span className="font-sm pr-1 text-primary">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="10"
                                  height="10"
                                  viewBox="0 0 10 10"
                                  fill="none"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M6 0H4V4H0V6H4V10H6V6H10V4H6V0Z"
                                    fill="#4161C8"
                                  />
                                </svg>
                              </span>
                              Add
                            </a>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}></td>
                        <td>
                          <div className="font-sm font-weight-semibold text-muted mt-2">
                            Total Sq. Ft.
                          </div>
                        </td>
                        <td>
                          <div className="font-sm font-weight-semibold text-muted mt-2">
                            Avail
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="border-bottom pt-2" colSpan={5}></td>
                      </tr>
                      <tr>
                        <td
                          colSpan={2}
                          className="font-sm font-weight-semibold text-muted py-3"
                        >
                          Combined Unit Total
                        </td>
                        <td className="font-sm font-weight-bold py-3">{props?.selectedOption?.unitData?.unitArea}</td>
                        <td className="font-sm font-weight-bold py-3">{props?.selectedOption?.unitData?.unitArea}</td>
                      </tr>
                      <tr>
                        <td className="border-bottom" colSpan={5}></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="px-3">
                  <div className="py-4">
                    <input
                      type="checkbox"
                      name="properyCheck-64ff2e18792fc21e609e8531"
                      id="idfor-split"
                      disabled={true}
                      checked={true}
                    />
                    <label htmlFor="idfor-split">
                      Update the Property Split in the property listings portal
                    </label>
                  </div>
                </div>
                <div className="p-3 text-right">
                  <button
                    type="submit"
                    className="btn btn-outline-primary font-normal font-weight-bold px-4 rounded Cancel mr-3"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary font-normal font-weight-bold px-4 rounded"
                    onClick={togglePreview}
                  >
                    Preview
                  </button>
                </div>
              </div>
            ) : (
              <div className="preview-details">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <th
                        className="font-sm font-weight-normal text-muted pb-2"
                        style={{ width: "160px" }}
                      >
                        Unit Name
                      </th>
                      <th
                        className="font-sm font-weight-normal text-muted pb-2"
                        style={{ width: "140px" }}
                      >
                        Available From
                      </th>
                      <th
                        className="font-sm font-weight-normal text-muted pb-2"
                        style={{ width: "115px" }}
                      >
                        Total Sq. Ft.
                      </th>
                      <th
                        className="font-sm font-weight-normal text-muted pb-2"
                        style={{ width: "115px" }}
                      >
                        Available Sq. Ft.
                      </th>
                      <th
                        className="font-sm font-weight-normal text-muted pb-2"
                        style={{ width: "180px" }}
                      >
                        Floorplan
                      </th>
                    </thead>
                    <tbody>
                      {splitUnits?.map((unit, index) => {
                        return (
                          <tr>
                            <td>
                              <div className="py-2">
                                <h5 className="font-sm font-weight-normal mb-0">
                                    {unit.unitName}
                                </h5>
                              </div>
                            </td>
                            <td>
                              <div className="py-2">
                                <h5 className="font-sm font-weight-normal mb-0">
                                  {formatDate(
                            unit.availableFrom,
                            DateFormats.NormalDateFormat
                          )}
                                </h5>
                              </div>
                            </td>
                            <td>
                              <div className="py-2">
                                <h5 className="font-sm font-weight-normal mb-0">
                                {unit.unitArea}
                                </h5>
                              </div>
                            </td>
                            <td>
                              <div className="py-2">
                                <h5 className="font-sm font-weight-normal mb-0">
                                {unit.unitArea}
                                </h5>
                              </div>
                            </td>
                            <td>
                              <div className="py-2">
                                <h5 className="mb-0 font-sm font-weight-normal pb-1">
                                  {unit?.floorPlan?.name}
                                </h5>
                                {/* <a className="font-sm font-weight-semibold text-decoration-underline text-primary cursor-pointer">
                                  View
                                </a> */}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td colSpan={5}>
                          <div className="border-top mt-2"></div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          <div className="font-sm font-weight-normal py-3 text-muted">
                            Combined Unit Total
                          </div>
                        </td>
                        <td>
                          <div className="font-weight-semibold font-sm py-3">
                            {props.selectedOption?.unitData?.unitArea}
                          </div>
                        </td>
                        <td>
                          <div className="font-weight-semibold font-sm py-3">
                          {props.selectedOption?.unitData?.unitArea}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={5}>
                          <div className="border-top"></div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={5}>
                          <div className="py-3 text-right">
                            <button
                              type="submit"
                              className="btn btn-outline-primary font-normal font-weight-bold px-4 rounded Cancel mr-3"
                              onClick={() => setIsVisible(true)}
                            >
                              Edit
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary font-normal font-weight-bold px-4 rounded"
                              onClick={() => onSubmit()}
                            >
                              Confirm & Save
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="modal-backdrop fade show"></div>
      </div>
      )}
    </>
  );
};

export default SplitMerge;
